import script from "./PreSportCouponsCompetitions.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportCouponsCompetitions.vue?vue&type=script&setup=true&lang=js"

import "./PreSportCouponsCompetitions.vue?vue&type=style&index=0&id=4467c273&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4467c273"]])

export default __exports__